export default {"src":"/_next/static/media/close-light.8f87a86d.svg","height":12,"width":12};